import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import React, { Fragment, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { TextField } from "@material-ui/core";

const Issuers = ({ issuers, visible, onChange, onBackClick, selected }) => {
    const [filter, setFilter] = useState("");
    const [filteredIssuers, setFilteredIssuers] = useState(issuers);

    const onFilterChange = (e) => {
        setFilter(e.target.value);
    };

    useEffect(() => {
        const filterByName = (issuer) => (issuer.issuer || "").toLowerCase().includes(filter.toLowerCase());
        if (filter && Array.isArray(issuers) && issuers.length > 0) {
            setFilteredIssuers(issuers.filter(filterByName));
        } else {
            setFilteredIssuers(issuers || []);
        }

        return () => {
            setFilteredIssuers([]);
        };
    }, [filter, issuers]);

    const renderIssuer = (issuer) => {
        return (
            <>
                <Card onClick={() => onChange(issuer)}>
                    <span>{issuer.issuer}</span>
                    <Icon name="arrow" color="secondary" size="xs" style={{ transform: "rotate(180deg)" }} />
                </Card>
            </>
        );
    };

    return (
        <div
            className={clsx("layout issuers-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && (
                <>
                    <Button secondary link onClick={selected ? onBackClick : undefined}>
                        <span>
                            <h3>Issuer</h3>
                        </span>
                        {selected && <Icon name="cancel" color="secondary" size="xs" />}
                    </Button>
                    <hr />
                    {!selected && (
                        <>
                            <small>
                                <i>Select an issuer for the form</i>
                            </small>
                            <TextField
                                name="issuers-filter-input"
                                className="issuers-filter-input"
                                type="text"
                                placeholder="Search ..."
                                value={filter}
                                onChange={onFilterChange}
                            />
                            <div className="issuers">
                                {filteredIssuers.map((issuer) => (
                                    <Fragment key={issuer.id}>{renderIssuer(issuer)}</Fragment>
                                ))}
                            </div>
                        </>
                    )}
                    {selected && (
                        <div className="issuers">
                            <Card>
                                <span>{selected.issuer}</span>
                            </Card>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

Issuers.propTypes = {
    issuers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            issuer: PropTypes.string,
            description: PropTypes.string,
            websiteUrl: PropTypes.string,
        })
    ),
    visible: PropTypes.bool,
    onChange: PropTypes.func,
    selected: PropTypes.shape({
        id: PropTypes.string,
        issuer: PropTypes.string,
        description: PropTypes.string,
        websiteUrl: PropTypes.string,
    }),
    onBackClick: PropTypes.func,
};

Issuers.defaultProps = {
    issuers: [],
    visible: true,
    onChange: () => {},
    selected: null,
    onBackClick: () => {},
};

export default Issuers;
